const STATE = 'state';
const MODE = 'mode';

export { STATE, MODE };
